<template>
  <div></div>
</template>

<script>
import { getWebSiteSchema, injectJsonLd } from '@/schema.config';

export default {
  name: 'CommonSearchActionSchemaComponent',
  mounted() {
    injectJsonLd('website-schema', getWebSiteSchema());
  },
};
</script>
